import { useEffect } from 'react';

/**
 * Used only on mobile for now!
 * @param condition {boolean} - True if scroll should be disabled
 */
export default condition => useEffect(() => {
	if (typeof window === 'undefined') {
		return;
	}
	if (window.innerWidth > 620) {
		return;
	}
	if (condition) {
		// When the modal is shown, we want a fixed body
		document.body.style.position = 'fixed';
		document.body.style.top = `-${window.scrollY}px`;
		document.body.style.right = '0';
		document.body.style.left = '0';

		// When the modal is hidden, we want to remain at the top of the scroll position
	} else {
		// When the modal is hidden, we want to remain at the top of the scroll position
		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.right = '';
		document.body.style.left = '';
	}
}, [condition]);
